import { render, staticRenderFns } from "./ModalRequestAppReview.vue?vue&type=template&id=3b2156a4"
import script from "./ModalRequestAppReview.vue?vue&type=script&lang=js"
export * from "./ModalRequestAppReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports